// API Configuration

// export const API_BASE_URL = "http://localhost:8080";
// export const API_BASE_URL = "http://tidyholidaysbackend-env-1.eba-4xcamnqy.eu-north-1.elasticbeanstalk.com";
// Change this value to update the API base URL across the entire application
export const API_BASE_URL = "https://api.tidyholidays.com";
// export const API_BASE_URL = "http://localhost:8080";

// Google Ads proxy (see /server folder) — never call the Google Ads API directly
// from the browser, it needs credentials that must stay server-side.
export const ADS_API_BASE_URL =
  process.env.REACT_APP_ADS_API_URL || "http://localhost:8081";

export const AVIATIONSTACK_BASE_URL = "https://api.aviationstack.com/v1/flights";
export const AVIATIONSTACK_KEY =
  process.env.REACT_APP_AVIATIONSTACK_KEY || "0a2ed1e54ba648b7374d27de2a1e3ee5";


